export const ACCOUNT_TYPE = {
    STUDENT: "Student",
    INSTRUCTOR: "Instructor",
    ADMIN: "Admin",
  }
  
  export const COURSE_STATUS = {
    DRAFT: "Draft",
    PUBLISHED: "Published",
  }


// Hamare project ke andar ye constant objects (ACCOUNT_TYPE aur COURSE_STATUS) role aur status define karne ke liye use ho rahe hain.